import React, { useEffect, useState } from "react";
import { Row, Col, Tag, Popover, Button } from "antd";
import { CheckOutlined, EditOutlined, } from "@ant-design/icons";

import api from "../../services/api";
import DrawerMatrizFilial from './drawer';
import { useStateValue } from '../../state';
import { MaskFormat, FormatFone } from "../../ValueObjects";
import { drawerActions, listagemActions, manutencaoActions } from "../../actions";
import { Editar, TabelaDados, BreadcrumbIncluirDados, PesquisaOrdenacao } from "../../components";
import { Tooltip, notification } from "antd";
import { mascaraIE } from "../../services/funcoesIE";

export default function MatrizFilial() {

    const [{ manutencao }, dispatch] = useStateValue();
    const [usuario, setUsuario] = useState(null);
    const [localInativo, setLocalInativo] = useState(false);

    useEffect(() => {
        const dadosSalvos = localStorage.getItem("@GestorWeb-DadosUsuario");
        if (dadosSalvos) {
            setUsuario(JSON.parse(dadosSalvos)); // Converte a string de volta para objeto
        }
        dispatch({ type: listagemActions.CHANGE, data: { outrosFiltros: '', filtro: '', ordem: 'loc_descricao' } });

    }, []);

    useEffect(() => {
        if (usuario) {
            VerificaLocal();
        }
    }, [usuario]);

    async function VerificaLocal() {
        let locAtivo = (await api.get('local/BuscarLocal')).data.loc_ativo;
        let tipoUsuario = usuario.Suporte;
        if (locAtivo == false && tipoUsuario == 'true') {
            setLocalInativo(true);
        }
    };

    async function AtivarLocal() {
        let locAtivo = (await api.get('local/AtivarLocal'));
        if(locAtivo.data == true){
            notification.success({ description: "Local Ativado com Sucesso! Efetue login para que a ativação seja aplicada", message: "Aviso" });
            setLocalInativo(false);
        } else {
            notification.error({ message: 'Erro ao ativar local !' });
        }
    };


    return (
        <div className="p-10">
            <BreadcrumbIncluirDados />
            <PesquisaOrdenacao opcoesOrdenacao={[
                { label: "Nome A - Z", value: "loc_descricao" },
                { label: "Nome Z - A", value: "-loc_descricao" },
                { label: "Código Crescente", value: "loc_codigo" },
                { label: "Código Decrescente", value: "-loc_codigo" }
            ]} />
            <div className="tabela">
                <TabelaDados url="local/ListarFiliaisEmpresa" colunas={[
                    {
                        title: 'Código',
                        width: 75,
                        align: 'center',
                        render: ({ loc_codigo, loc_ativo }) => (
                            <Popover content={loc_ativo ? 'Ativo' : 'Inativo'} placement="right" className="w-100">
                                <Tag color={loc_ativo ? 'processing' : 'default'}>
                                    <b>{loc_codigo}</b>
                                </Tag>
                            </Popover>
                        ),
                    },
                    {
                        title: 'Filial',
                        width: '30%',
                        render: ({ loc_matriz, loc_ativo, loc_descricao }) => (
                            <div style={{ display: 'flex' }}>
                                <Row align="middle" gutter={[5, 0]}>
                                    <Col>
                                        <Popover content={loc_ativo ? 'Ativo' : 'Inativo'} placement="right">
                                            <Tag color={loc_ativo ? 'processing' : 'default'}>
                                                <b>{loc_matriz ? 'Matriz' : 'Filial'}</b>
                                            </Tag>
                                        </Popover>
                                    </Col>
                                    <Col>
                                        <b>{loc_descricao}</b>
                                    </Col>
                                </Row>
                            </div>
                        ),
                    },
                    {
                        title: 'CPF/CNPJ',
                        render: ({ loc_cnpj, loc_cpf }) => (
                            <div>
                                <b>{loc_cnpj.numero ? MaskFormat(loc_cnpj.numero, '', true) : MaskFormat(loc_cpf.numero, '', true)}</b>
                            </div>
                        ),
                    },
                    {
                        title: 'I.E',
                        render: ({ loc_inscricaoestadual }) => (
                            <div>
                                <b>{loc_inscricaoestadual.numeroInscricaoEstadual ? mascaraIE(loc_inscricaoestadual.numeroInscricaoEstadual, loc_inscricaoestadual.ufEstado) : 'Não Informado'}</b>
                            </div>
                        ),
                    },
                    {
                        title: 'I.M',
                        render: ({ loc_inscricaomunicipal }) => (
                            <div>
                                <b>{(!!loc_inscricaomunicipal) ? (loc_inscricaomunicipal) : 'Não Informada'}</b>
                            </div>
                        ),
                    },
                    {
                        title: 'Telefone',
                        render: ({ loc_telefone }) => (
                            <div>
                                <b>{(!!loc_telefone) ? FormatFone(loc_telefone) : 'Não Informado'}</b>
                            </div>
                        ),
                    },
                    {
                        title: 'Ações',
                        dataIndex: '',
                        key: 'x',
                        align: 'center',
                        width: 95,
                        fixed: 'right',
                        render: (record, dados) => (
                            <div>
                                <Row align="middle" justify="center" gutter={[5, 0]}>
                                    <Col>
                                        <Editar
                                            onClick={() => {
                                                dispatch({ type: manutencaoActions.CHANGE, data: { dados: record } });
                                                dispatch({ type: drawerActions.CHANGE, data: { showDrawer: true } });
                                            }} icon={<EditOutlined />}
                                        />
                                    </Col>
                                    {record.loc_ativo === false && <Col>
                                        <Tooltip title="Ativar Local">
                                            <Button
                                                type={localInativo ? "primary" : "default"}
                                                icon={<CheckOutlined />}
                                                onClick={() => AtivarLocal()}
                                            />
                                        </Tooltip>
                                    </Col>}
                                </Row>
                            </div>
                        ),
                    },
                ]} expandir={({ loc_numeroestabelecimento, loc_email, loc_telefone, logradouroCidade }) => {
                    return (
                        <div>
                            <Row align="middle" justify="space-between" gutter={[8, 0]}>
                                <Col>
                                    Endereco : <b>{logradouroCidade.logradouro.log_logradouro} {loc_numeroestabelecimento}, {logradouroCidade.bairro.bai_nome}, {logradouroCidade.cidade.cid_descricao}-{logradouroCidade.cidade.estado.est_sigla}</b>
                                </Col>
                                <Col>
                                    Email: {loc_email.endereco}
                                </Col>
                                <Col>
                                    Telefone: {loc_telefone}
                                </Col>
                            </Row>
                        </div>
                    )
                }} />
            </div>
            <DrawerMatrizFilial />
        </div>
    );
}